import MarketProfile from "./marketProfile";
import { useTranslation } from "../../../../i18n/useTranslation";

const MarketIndia = () => {
  const { t } = useTranslation();
  return (
    <MarketProfile
      tag="India · Bharat"
      name="Tapaswe Bharat"
      intro={t("marketsIndia.intro")}
      offices={[{ label: "", address: "Mumbai, Maharashtra, India" }]}
      officesTitle={t("marketProfile.office")}
      ceo="Nalin Tewari — Acting CEO"
      ceoLinkedIn="https://www.linkedin.com/in/nalintewari"
    />
  );
};

export default MarketIndia;
